import { Base } from '@studiometa/js-toolkit';
import Readmore from '#js/molecules/Readmore.js';
import ImageZoom from '#js/molecules/ImageZoom.js';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @extends {Base<ComponentProps>}
 */
export default class Single extends Base {
  currentImage = null;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Single',
    components: {
      Readmore,
      ImageZoom,
    },
    refs: [
      'installationView',
      'selectedWorks',
      'galleryBtn[]',
      'readmorePanel',
      'closePanel',
      'images[]',
    ],
  };

  /**
   * Mount Component
   * @returns {void}
   */
  mounted() {
    [, this.currentBtn] = this.$refs.galleryBtn;
    this.gallery = this.$refs.selectedWorks;
    this.galleries = [this.$refs.selectedWorks, this.$refs.installationView];
  }

  /**
   *
   */
  onClosePanelClick() {
    this.closeReadmorePanel();
  }

  /**
   *
   */
  onReadmoreOpenPanel() {
    this.openReadmorePanel();
  }

  /**
   *
   */
  openReadmorePanel() {
    this.$refs.readmorePanel.classList.remove('translate-y-full');
  }

  /**
   *
   */
  closeReadmorePanel() {
    this.$refs.readmorePanel.classList.add('translate-y-full');
  }

  /**
   * Click on galleries btn
   * @param  {object} e current btn
   * @returns {void}
   */
  onGalleryBtnClick(e) {
    if (this.gallery === this.$refs[e.currentTarget.id]) {
      return;
    }

    this.currentBtn.classList.remove('opacity-100');
    this.currentBtn.classList.add('opacity-50');
    this.currentBtn = e.currentTarget;
    this.currentBtn.classList.add('opacity-100');
    this.currentBtn.classList.remove('opacity-50');

    this.hideCurrentGallery(this.currentBtn.id);
  }

  /**
   * Hide currentGallery
   * @param  {string} galleryName gallery name
   * @returns {void}
   */
  hideCurrentGallery(galleryName) {
    window.scrollTo(0, 500);
    setTimeout(() => {
      this.gallery.classList.remove('gallery--visible');
      setTimeout(() => {
        this.gallery.style.display = 'none';
        this.gallery = this.$refs[galleryName];
        this.showNewGallery();
      }, 800);
    }, 500);
  }

  /**
   * Show new gallery
   * @returns {void}
   */
  showNewGallery() {
    this.gallery.style.display = 'block';

    setTimeout(() => {
      this.gallery.classList.add('gallery--visible');
      window.scrollTo(0, 0);
    }, 300);
  }
}
